"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.UserImage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_native_1 = require("react-native");
var platform_1 = require("@hiyllo/ux/platform");
var use_user_profile_picture_src_1 = require("../hooks/use-user-profile-picture-src");
var contexts_1 = require("../contexts");
var centered_1 = require("./centered");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var NativeImage = react_1["default"].memo(function NativeImage(props) {
    var style = react_1["default"].useMemo(function () { return ({
        width: props.width,
        height: props.width,
        borderRadius: props.width * 0.25
    }); }, [props.width]);
    if (react_native_1.Platform.OS === "web") {
        return ((0, jsx_runtime_1.jsx)("img", { src: props.src, style: style }));
    }
    else {
        return ((0, jsx_runtime_1.jsx)(react_native_1.Image, { source: { uri: props.src }, style: style }));
    }
});
var UserImage = function (props) {
    var src = (0, use_user_profile_picture_src_1.useUserProfilePictureSrc)(props.userId);
    var BlobCache = react_1["default"].useContext(contexts_1.BlobCacheProviderContext);
    var FontAwesomeIcon = react_1["default"].useContext(platform_1.FontAwesomeIconCtx);
    if (BlobCache == null) {
        throw new Error('BlobCacheProviderContext is null');
    }
    return src != null
        ? ((0, jsx_runtime_1.jsx)(NativeImage, { src: src, width: props.width }))
        : ((0, jsx_runtime_1.jsx)(centered_1.Centered, __assign({ style: {
                width: props.width,
                height: props.width,
                borderRadius: props.width * 0.25,
                backgroundColor: 'rgba(255, 255, 255, 0.1)'
            } }, { children: FontAwesomeIcon != null ?
                (0, jsx_runtime_1.jsx)(FontAwesomeIcon, __assign({ icon: pro_light_svg_icons_1.faUserCircle, size: props.width * 0.5 }, (react_native_1.Platform.OS === 'web' ? { fontSize: props.width * 0.5 } : {})))
                :
                    (0, jsx_runtime_1.jsx)(BlobCache.LoadingComponent, {}) })));
};
exports.UserImage = UserImage;
